import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpResponse } from '@angular/common/http';
import { DynamicAttributes, OCC_USER_ID_CURRENT, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

export const defaultFileName = 'file';

@Injectable({
  providedIn: 'root',
})
export class SlbOccConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  get<T>(
    endpoint: string,
    urlParams?: object,
    queryParams?: object,
    options?: object,
  ): Observable<T> {
    return this.httpClient.get<T>(
      this._getUrl(endpoint, urlParams, queryParams),
      options,
    );
  }

  post<T>(
    endpoint: string,
    urlParams?: object,
    queryParams?: object,
    body?: object,
  ): Observable<T> {
    return this.httpClient.post<T>(
      this._getUrl(endpoint, urlParams, queryParams),
      body,
    );
  }

  patch<T>(
    endpoint: string,
    urlParams?: object,
    queryParams?: object,
    body?: object,
  ): Observable<T> {
    return this.httpClient.patch<T>(
      this._getUrl(endpoint, urlParams, queryParams),
      body,
    );
  }

  put<T>(
    endpoint: string,
    urlParams?: object,
    queryParams?: object,
    body?: object,
    options?: object,
  ): Observable<T> {
    return this.httpClient.put<T>(
      this._getUrl(endpoint, urlParams, queryParams),
      body,
      options,
    );
  }

  delete<T>(
    endpoint: string,
    urlParams?: object,
    queryParams?: object,
    options?: object,
  ): Observable<T> {
    return this.httpClient.delete<T>(
      this._getUrl(endpoint, urlParams, queryParams),
      options,
    );
  }

  sendFormData<T>(
    endpoint: string,
    formData: FormData,
    urlParams?: object,
    queryParams?: object,
  ): Observable<HttpEvent<T>> {
    return this.httpClient.post<T>(
      this._getUrl(endpoint, urlParams, queryParams),
      formData,
      {
        reportProgress: true,
        observe: 'events',
      },
    );
  }

  postWithHttpResponse<T>(
    endpoint: string,
    urlParams?: object,
    queryParams?: object,
    body?: object,
  ): Observable<HttpResponse<T>> {
    return this.httpClient.post<T>(
      this._getUrl(endpoint, urlParams, queryParams),
      body,
      {
        observe: 'response',
      },
    );
  }

  private _getUrl(
    endpoint: string,
    urlParams?: object,
    queryParams?: object,
  ): string {
    const attributes: DynamicAttributes = {
      urlParams: { ...urlParams, userId: OCC_USER_ID_CURRENT },
      queryParams: { ...queryParams },
    };
    return this.occEndpointsService.buildUrl(endpoint, attributes);
  }
}
